import { ArrowBack } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { ConfirmModalContext, ModalProps } from "context/confirmModalContext";
import { NavigationHistoryContext } from "context/navigationHistoryContext";
import { useContext } from "react";
import { BackPageButtonValue } from "./types";
import { useGetBackPageButtonProps } from "./useGetBackPageButtonProps";

type ConfirmNavigationModalProps = Partial<Omit<ModalProps, "handleClick">> & {
  shouldConfirm: boolean;
};

type BackPageButtonProps = {
  defaultValue: BackPageButtonValue;
  getSearch?: () => string | undefined;
  confirmNavigationModalProps?: ConfirmNavigationModalProps;
};
const BackPageButton = ({ defaultValue, getSearch, confirmNavigationModalProps }: BackPageButtonProps) => {
  const { backNavigate } = useContext(NavigationHistoryContext);
  const { handleOpen: handleOpenConfirmModal } = useContext(ConfirmModalContext);
  const value = useGetBackPageButtonProps({ defaultValue, getSearch });

  const { link, text } = value || {};

  const handleNavigate = () => {
    if (!link) return;

    if (confirmNavigationModalProps?.shouldConfirm) {
      const { shouldConfirm, ...modalProps } = confirmNavigationModalProps;

      handleOpenConfirmModal({
        title: "Покинуть страницу?",
        description: "Все введённые данные будут потеряны.",
        actionButtonText: "Выйти",
        handleClick: () => backNavigate({ reserveLocation: link }),
        ...modalProps,
      });
      return;
    }

    backNavigate({ reserveLocation: link });
  };

  return (
    <Button
      disabled={!link}
      onClick={handleNavigate}
      startIcon={<ArrowBack />}
      sx={{ mb: 1.5, p: 0, justifyContent: "flex-start", color: "base.200" }}>
      {text || ""}
    </Button>
  );
};

export default BackPageButton;
